import { useEffect, useState } from 'react';
import { HUD_ASYNC_DATA_REFRESH_POLL_MS } from './constants';

const useHUDAsyncDataQueryInterval = (hudAsyncDataRefreshUntil = null) => {
  const [isPollingHudAsyncData, setIsPollingHudAsyncData] = useState(
    hudAsyncDataRefreshUntil != null && hudAsyncDataRefreshUntil > Date.now(),
  );

  useEffect(() => {
    if (hudAsyncDataRefreshUntil == null) {
      setIsPollingHudAsyncData(false);
      return undefined;
    }

    const remainingMs = hudAsyncDataRefreshUntil - Date.now();
    if (remainingMs <= 0) {
      setIsPollingHudAsyncData(false);
      return undefined;
    }

    setIsPollingHudAsyncData(true);
    const t = setTimeout(() => setIsPollingHudAsyncData(false), remainingMs);
    return () => clearTimeout(t);
  }, [hudAsyncDataRefreshUntil]);

  return isPollingHudAsyncData ? HUD_ASYNC_DATA_REFRESH_POLL_MS : false;
};

export default useHUDAsyncDataQueryInterval;
